import React from 'react';

import { useServices } from 'hooks/useServices';
import { useAsyncBoundary } from 'utils/asyncBoundary/asyncBoundaryHooks';
import { useAppState } from 'hooks/useAppState';
import { useAppDispatcher } from 'hooks/useAppDispatcher';

export const useProdStackInfoProcess = () => {
  const { prodStackInfo } = useAppState();

  const { getProdStackInfo } = useServices();

  const { injectPromise } = useAsyncBoundary();

  const dispatch = useAppDispatcher();

  const shouldFetchProdStackInfo = prodStackInfo === undefined;

  React.useLayoutEffect(() => {
    if (shouldFetchProdStackInfo) {
      const promise = getProdStackInfo().then((prodStackInfo) => {
        dispatch({
          name: 'ProdStackInfoResolved',
          prodStackInfo,
        });
      });

      injectPromise(promise);
    }
  }, [dispatch, getProdStackInfo, injectPromise, shouldFetchProdStackInfo]);
};
